import IdentityGenderSelectionButtons from './IdentityGenderSelectionButtons';

export default IdentityGenderSelectionButtons;
